// extracted by mini-css-extract-plugin
export default {"floatButton":"LiveChat_floatButton__JJR20","liveChat":"LiveChat_liveChat__0c+VB"};